import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { RoleResource } from "@exonn/js-sdk";

export const module: ModuleOptions<RoleResource> = {
  resource: ResourceEnum.Role,
  smallIcon: <i className={"icon-15-rights_profiles"} />,
  bigIcon: <i className={"icon-20-rights_profiles"} />,

  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
